$(function (){
    $("#input-agb").on('click', function () {
        let agbIsChecked = $(this).is(":checked");
        agbIsChecked = !agbIsChecked;
        $(".agb-accept").prop('disabled', agbIsChecked);
    });
});
